import React from "react";
import Main from "./Sections/Main";

export default function index() {
  return (
    <div className="">
      <Main />
    </div>
  );
}
